import classNames from 'classnames';
import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import LanguageIcon from '../../../assets/language.svg';
import { LanguageDisplay } from '../LanguageDisplay/LanguageDisplay';

import styles from './SingleValue.module.scss';

export const SingleValue: SelectComponentsConfig<
  { name: string; id: string },
  false,
  GroupBase<{ name: string; id: string }>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['SingleValue'] = ({ children, className, ...props }) => {
  const customStyles = (props as any).selectProps?.customStyles;

  return (
    <components.SingleValue className={classNames(className, styles.singleValue)} {...props}>
      {props.selectProps.showSingleValuePrefixIcon && (
        <img alt="lang" className={styles.prefixIcon} src={LanguageIcon} style={customStyles?.icon} />
      )}
      <LanguageDisplay
        customStyles={customStyles}
        language={props.data}
        showShortLanguageCode={props.selectProps.showShortLanguageCode}
      />
    </components.SingleValue>
  );
};
